module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAN0lEQVQ4y2NgGBRg9eo7/xkYpvzHR59hYMDASEbg1wyisYFRF1DTBf/JBHADsJlODB5ELhjaAACBeJhhrvaiHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/US.png
// module id = 1292
// module chunks = 0